import { render, staticRenderFns } from "./read-content.vue?vue&type=template&id=6c00a3f2&scoped=true&"
import script from "./read-content.vue?vue&type=script&lang=js&"
export * from "./read-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00a3f2",
  null
  
)

export default component.exports